// ==========================================================================
// Bakhtawar Furniture Lahore - Dynamic Bespoke Theme Engine
// Handcrafted Heirloom Furniture · Mortise & Tenon Craftsmanship
// ==========================================================================

const WHATSAPP_NUMBER = window.SHOP_WHATSAPP || "923111555381";
const STORE_ADDRESS = window.SHOP_ADDRESS || "47-F Main Market Gulberg-II, Lahore Pakistan";

// Helper to resolve local SVG assets safely
function getAsset(key) {
  if (window.THEME_ASSETS && window.THEME_ASSETS[key]) {
    return window.THEME_ASSETS[key];
  }
  return `placeholder-${key}.svg`;
}

// Default Baseline Catalog (100% Self-Contained Local Vector Visuals · Zero External Requests)
const defaultProducts = [
  {
    id: 1,
    name: "Royal Chiniot Carved Bed Set",
    sku: "SKU: BF01004120",
    category: "bedroom",
    woodType: "sheesham",
    woodLabel: "100% Solid Seasoned Sheesham",
    images: [getAsset("bed")],
    badge: "🔥 Signature Masterpiece",
    bullets: [
      "Handcrafted in 100% seasoned solid Sheesham (Tahli) wood for lifetime durability",
      "Features exquisite deep-relief Chinioti floral carving on the grand headboard",
      "Includes King Size Bed Frame and 2 matching single-drawer bedside nightstands",
      "Traditional mortise-and-tenon interlocking joinery — zero staples or loose screws",
      "Custom sizing available to suit your master bedroom space",
      "Hand-rubbed natural lacquer finish resists humidity and daily wear"
    ]
  },
  {
    id: 2,
    name: "Cane Elegance Bed",
    sku: "SKU: BF01008891",
    category: "bedroom",
    woodType: "sheesham",
    woodLabel: "100% Solid Seasoned Sheesham",
    images: [getAsset("dresser")],
    badge: "✨ Hand-Polished",
    bullets: [
     "Features exquisite deep-relief Chinioti floral carving on the grand headboard",
      "Includes King Size Bed Frame and 2 matching single-drawer bedside nightstands",
      "Traditional mortise-and-tenon interlocking joinery — zero staples or loose screws",
      "Custom sizing available to suit your master bedroom space",
      "Hand-rubbed natural lacquer finish resists humidity and daily wear"
    ]
  },
  {
    id: 3,
    name: "Golden Reverie Bed",
    sku: "SKU: BF02003340",
    category: "bedroom",
    woodType: "walnut",
    woodLabel: "Royal Pakistani Walnut",
    images: [getAsset("table")],
    badge: "Pair (2 Pcs)",
    bullets: [
     "Includes King Size Bed Frame and 2 matching single-drawer bedside nightstands",
     "Traditional mortise-and-tenon interlocking joinery — zero staples or loose screws",
     "Custom sizing available to suit your master bedroom space",
     "Hand-rubbed natural lacquer finish resists humidity and daily wear"
    ]
  },
  {
    id: 4,
    name: "Golden Throne Chairs",
    sku: "SKU: BF03002240",
    category: "living",
    woodType: "walnut",
    woodLabel: "Solid Hardwood Frame & Velvet",
    images: [getAsset("sofa")],
    badge: "👑 Royal Living",
    bullets: [
      "Iconic British deep-buttoned tufting executed by master craftsmen",
      "Kiln-dried solid hardwood internal frame with lifetime anti-sag guarantee",
      "Upholstered in royal emerald velvet with antique brass nailhead trim"
    ]
  },
  {
    id: 5,
    name: "Timeless Wingback Duo",
    sku: "SKU: BF03005510",
    category: "living",
    woodType: "sheesham",
    woodLabel: "Solid Sheesham Base & Textured Fabric",
    images: [getAsset("sofa")],
    badge: "☕ Cozy Classic",
    bullets: [
      "A hand-sculpted sheesham frame, finished in ivory and gold with soft teal upholstery ",
      "Solid Sheesham timber base and legs with reinforced corner blocks",
      "The signature piece of the ‘Crafted for Timeless Luxury’ collection."
    ]
  },
  {
    id: 6,
    name: "Imperial Gold Sofa Set",
    sku: "SKU: BF04001150",
    category: "living",
    woodType: "walnut",
    woodLabel: "Royal Single-Slab Walnut",
    images: [getAsset("table")],
    badge: "🌿 100% Organic Finish",
    bullets: [
      "A five-seater carved royal sofa set in cream-gold fabric ",
      "A grand living room presence sure to impress every guest.",
      "Sealed with organic beeswax and natural botanical wood oils"
    ]
  },
  {
    id: 7,
    name: "Royal Banquet Dining Set",
    sku: "SKU: BF05007780",
    category: "dining",
    woodType: "sheesham",
    woodLabel: "100% Solid Seasoned Sheesham",
    images: [getAsset("dining")],
    badge: "🍷 Grand Feast",
    bullets: [
      "An eight-seater hand-carved sheesham dining set finished in antique silver ",
      "A grand table befitting distinguished guests and special occasions."
    ]
  },
  {
    id: 8,
    name: "Executive Presidential CEO Desk",
    sku: "SKU: BF06009900",
    category: "office",
    woodType: "walnut",
    woodLabel: "Royal Dark Walnut",
    images: [getAsset("desk")],
    badge: "💼 Executive Luxury",
    bullets: [
      "Imposing executive office desk with rich dark walnut hand-polish",
      "Features full-grain leatherette writing inlay with concealed cable channels",
      "6 lockable filing drawers equipped with heavy-duty soft closing slides"
    ]
  },
  {
    id: 9,
    name: "Ivory-gold swing",
    sku: "SKU: BF07003310",
    category: "storage",
    woodType: "sheesham",
    woodLabel: "100% Solid Seasoned Sheesham",
    images: [getAsset("wardrobe")],
    badge: "🚪 German Sliding Tracks",
    bullets: [
      "An ivory-gold swing crafted from solid sheesham wood, combining sturdy construction with fine carving",
      "Araceful centrepiece for any lounge or verandah.",
    ]
  }
];

// Combine Live Shopify Store Products with Baseline Catalog
let products = [...defaultProducts];

function initProducts() {
  try {
    const liveEl = document.getElementById("shopify-live-products-json");
    if (liveEl) {
      const liveItems = JSON.parse(liveEl.textContent || "[]");
      if (Array.isArray(liveItems) && liveItems.length > 0) {
        const validLive = liveItems.filter(item => item && item.name);
        if (validLive.length > 0) {
          const liveNames = new Set(validLive.map(p => p.name.trim().toLowerCase()));
          const remainingDemo = defaultProducts.filter(d => !liveNames.has(d.name.trim().toLowerCase()));
          products = [...validLive, ...remainingDemo];
        }
      }
    }
  } catch (err) {
    console.warn("Using default handcrafted catalog", err);
  }
}

const categories = [
  { id: "all", label: "All Masterpieces", icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>' },
  { id: "bedroom", label: "Bedroom", icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 4v16M2 8h18a2 2 0 0 1 2 2v10M2 17h20M6 8v9"/></svg>' },
  { id: "living", label: "Living & Sofas", icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0z"/><path d="M4 18v2M20 18v2"/></svg>' },
  { id: "dining", label: "Dining & Bar", icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="9" x2="21" y2="9"/><line x1="5" y1="9" x2="5" y2="20"/><line x1="19" y1="9" x2="19" y2="20"/><line x1="8" y1="9" x2="8" y2="15"/><line x1="16" y1="9" x2="16" y2="15"/></svg>' },
  { id: "storage", label: "Wardrobes", icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="12" y1="3" x2="12" y2="21"/></svg>' }
];

let activeCategory = "all";
let currentSearch = "";
let currentSort = "featured";
let currentWood = "all";
let cart = JSON.parse(localStorage.getItem("bf_cart") || "[]");
let wishlist = JSON.parse(localStorage.getItem("bf_wishlist") || "[]");

let currentPdpProduct = null;
let currentPdpImageIndex = 0;
let currentPdpQty = 1;
let touchStartX = 0;

function renderCategories() {
  const container = document.getElementById("catGrid");
  if (!container) return;
  container.innerHTML = categories.map(c => `
    <div class="cat-tab ${c.id === activeCategory ? 'active' : ''}" onclick="setCategory('${c.id}')">
      ${c.icon}
      <span>${c.label}</span>
    </div>
  `).join("");
}

function setCategory(id) {
  activeCategory = id;
  renderCategories();
  renderProducts();
}

function handleSearch() {
  const el = document.getElementById("searchInput");
  if (el) currentSearch = el.value.trim().toLowerCase();
  renderProducts();
}

function handleSort() {
  const el = document.getElementById("sortSelect");
  if (el) currentSort = el.value;
  renderProducts();
}

function handleWoodFilter() {
  const el = document.getElementById("woodFilter");
  if (el) currentWood = el.value;
  renderProducts();
}

// Render Products Grid
function renderProducts() {
  const grid = document.getElementById("prodGrid");
  if (!grid) return;

  let list = [...products];

  if (activeCategory !== "all") {
    list = list.filter(p => p.category === activeCategory);
  }
  if (currentWood !== "all") {
    list = list.filter(p => p.woodType === currentWood);
  }
  if (currentSearch) {
    list = list.filter(p => 
      p.name.toLowerCase().includes(currentSearch) ||
      (p.sku && p.sku.toLowerCase().includes(currentSearch))
    );
  }

  if (currentSort === "name") {
    list.sort((a, b) => a.name.localeCompare(b.name));
  }

  const defaultImg = getAsset("furniture");

  grid.innerHTML = list.map(p => {
    const isSaved = wishlist.includes(String(p.id));
    const firstImg = (p.images && p.images.length > 0) ? p.images[0] : defaultImg;

    return `
      <div class="prod-card" onclick="openProductDetailModal('${p.id}')">
        <div class="prod-img-box">
          <img src="${firstImg}" alt="${p.name}" loading="lazy">
          <span class="prod-badge">${p.badge || '✨ Masterpiece'}</span>
          <button class="prod-wish-btn ${isSaved ? 'saved' : ''}" onclick="event.stopPropagation(); toggleWishlist('${p.id}')" aria-label="Save to Wishlist">
            <svg viewBox="0 0 24 24" fill="${isSaved ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
          </button>
        </div>

        <div class="prod-body">
          <div class="prod-wood-tag">🪵 ${p.woodLabel}</div>
          <h3>${p.name}</h3>
          
          <div class="prod-spec-row">
            <span class="prod-pill">Handcrafted to Order</span>
            <span class="prod-pill">Mortise Joinery</span>
          </div>

          <div class="prod-foot">
            <button class="btn-quick" onclick="event.stopPropagation(); openProductDetailModal('${p.id}')">
              🔍 View Details
            </button>
            <button class="btn-add-cart" onclick="event.stopPropagation(); addToCart('${p.id}')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Add to Inquiry
            </button>
          </div>
        </div>
      </div>
    `;
  }).join("");
}

// Bespoke Product Detail Modal
function openProductDetailModal(id) {
  const p = products.find(x => String(x.id) === String(id));
  if (!p) return;

  currentPdpProduct = p;
  currentPdpImageIndex = 0;
  currentPdpQty = 1;

  document.getElementById("pdpBreadcrumbTitle").textContent = p.name;
  document.getElementById("pdpTitle").textContent = p.name;
  document.getElementById("pdpSku").textContent = p.sku || `SKU: BF00${p.id}`;
  document.getElementById("pdpQtyNum").textContent = "1";

  const defaultImg = getAsset("furniture");
  const thumbStrip = document.getElementById("pdpVerticalThumbnails");
  const imgs = (p.images && p.images.length > 0) ? p.images : [defaultImg];

  thumbStrip.innerHTML = imgs.map((img, idx) => `
    <div class="pdp-strip-thumb ${idx === 0 ? 'active' : ''}" onclick="selectPdpImage(${idx})">
      <img src="${img}" alt="Angle ${idx + 1}">
    </div>
  `).join("");

  document.getElementById("pdpMainImg").src = imgs[0];

  const bulletsList = document.getElementById("pdpBulletsList");
  if (bulletsList) {
    const bullets = Array.isArray(p.bullets) ? p.bullets : [
      "100% Solid Seasoned Hardwood construction",
      "Handcrafted by generational artisans in Lahore",
      "White-Glove In-Home Delivery & Installation included"
    ];
    bulletsList.innerHTML = bullets.map(b => `<li>${b}</li>`).join("");
  }

  document.getElementById("pdpModalOverlay").classList.add("open");
  document.body.classList.add("no-scroll");
}

function selectPdpImage(idx) {
  if (!currentPdpProduct || !currentPdpProduct.images || !currentPdpProduct.images[idx]) return;
  currentPdpImageIndex = idx;
  document.getElementById("pdpMainImg").src = currentPdpProduct.images[idx];

  const thumbs = document.querySelectorAll(".pdp-strip-thumb");
  thumbs.forEach((t, i) => t.classList.toggle("active", i === idx));
}

function prevProductImage(e) {
  if (e) e.stopPropagation();
  if (!currentPdpProduct || !currentPdpProduct.images) return;
  let nextIdx = currentPdpImageIndex - 1;
  if (nextIdx < 0) nextIdx = currentPdpProduct.images.length - 1;
  selectPdpImage(nextIdx);
}

function nextProductImage(e) {
  if (e) e.stopPropagation();
  if (!currentPdpProduct || !currentPdpProduct.images) return;
  let nextIdx = currentPdpImageIndex + 1;
  if (nextIdx >= currentPdpProduct.images.length) nextIdx = 0;
  selectPdpImage(nextIdx);
}

function handleTouchStart(e) {
  touchStartX = e.changedTouches[0].screenX;
}

function handleTouchEnd(e) {
  const touchEndX = e.changedTouches[0].screenX;
  const diff = touchEndX - touchStartX;
  if (Math.abs(diff) > 40) {
    if (diff < 0) nextProductImage();
    else prevProductImage();
  }
}

function handleZoomMove(e) {
  if (window.innerWidth <= 768) return;
  const canvas = document.getElementById("pdpCanvas");
  const img = document.getElementById("pdpMainImg");
  if (!canvas || !img) return;

  const rect = canvas.getBoundingClientRect();
  const x = ((e.clientX - rect.left) / rect.width) * 100;
  const y = ((e.clientY - rect.top) / rect.height) * 100;

  img.style.transformOrigin = `${x}% ${y}%`;
  img.style.transform = "scale(2.2)";
}

function handleZoomLeave() {
  const img = document.getElementById("pdpMainImg");
  if (!img) return;
  img.style.transformOrigin = "center center";
  img.style.transform = "scale(1)";
}

function adjustPdpQty(delta) {
  currentPdpQty = Math.max(1, currentPdpQty + delta);
  document.getElementById("pdpQtyNum").textContent = currentPdpQty;
}

function closeProductDetailModal() {
  const modal = document.getElementById("pdpModalOverlay");
  if (modal) modal.classList.remove("open");
  document.body.classList.remove("no-scroll");
}

function handlePdpModalBackdrop(e) {
  if (e.target.id === "pdpModalOverlay") closeProductDetailModal();
}

function addPdpToCart() {
  if (!currentPdpProduct) return;
  const existing = cart.find(i => String(i.id) === String(currentPdpProduct.id));
  const fallbackImg = getAsset("furniture");
  const img = (currentPdpProduct.images && currentPdpProduct.images.length > 0) ? currentPdpProduct.images[0] : fallbackImg;

  if (existing) {
    existing.qty += currentPdpQty;
  } else {
    cart.push({ ...currentPdpProduct, qty: currentPdpQty, image: img });
  }
  saveCart();
  showToast(`Added ${currentPdpQty}x ${currentPdpProduct.name} to Inquiry List`);
  closeProductDetailModal();
  openCart();
}

function orderPdpWhatsApp() {
  if (!currentPdpProduct) return;
  let msg = `*👑 BAKHTAWAR FURNITURE ORDER INQUIRY*\n`;
  msg += `------------------------------------\n`;
  msg += `• *Product:* ${currentPdpProduct.name}\n`;
  msg += `• *${currentPdpProduct.sku || 'SKU: BF00' + currentPdpProduct.id}*\n`;
  msg += `• *Quantity:* ${currentPdpQty}\n`;
  msg += `• *Wood:* ${currentPdpProduct.woodLabel}\n`;
  msg += `• *Delivery:* White-Glove Delivery & Assembly (Lahore & Nationwide)\n`;
  msg += `------------------------------------\n`;
  msg += `Showroom: ${STORE_ADDRESS}\n`;
  msg += `Please share current quotation, timber availability, and production timeline. Thank you!`;
  window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, "_blank");
}

function addToCart(id) {
  const p = products.find(x => String(x.id) === String(id));
  if (!p) return;
  const existing = cart.find(i => String(i.id) === String(id));
  const fallbackImg = getAsset("furniture");
  const img = (p.images && p.images.length > 0) ? p.images[0] : fallbackImg;

  if (existing) {
    existing.qty += 1;
  } else {
    cart.push({ ...p, qty: 1, image: img });
  }
  saveCart();
  renderCartDrawer();
  showToast(`Added ${p.name} to Inquiry List`);
}

function changeQty(id, delta) {
  const item = cart.find(i => String(i.id) === String(id));
  if (!item) return;
  item.qty += delta;
  if (item.qty <= 0) {
    cart = cart.filter(i => String(i.id) !== String(id));
  }
  saveCart();
  renderCartDrawer();
}

function removeCartItem(id) {
  cart = cart.filter(i => String(i.id) !== String(id));
  saveCart();
  renderCartDrawer();
  showToast("Item removed from inquiry list");
}

function saveCart() {
  localStorage.setItem("bf_cart", JSON.stringify(cart));
  const count = cart.reduce((sum, item) => sum + item.qty, 0);
  const cartBadge = document.getElementById("cartCount");
  const wishBadge = document.getElementById("wishlistCount");
  if (cartBadge) cartBadge.textContent = count;
  if (wishBadge) wishBadge.textContent = wishlist.length;
}

function renderCartDrawer() {
  const itemsContainer = document.getElementById("cartDrawerItems");
  const foot = document.getElementById("cartDrawerFoot");
  if (!itemsContainer) return;

  if (cart.length === 0) {
    itemsContainer.innerHTML = `<div class="drawer-empty"><p>Your inquiry list is currently empty.</p></div>`;
    if (foot) foot.style.display = "none";
    return;
  }

  if (foot) foot.style.display = "block";
  const defaultImg = getAsset("furniture");

  itemsContainer.innerHTML = cart.map(item => {
    const thumb = (item.images && item.images.length > 0) ? item.images[0] : (item.image || defaultImg);
    return `
      <div class="cart-item-row">
        <img src="${thumb}" alt="${item.name}" class="cart-item-img">
        <div class="cart-item-info">
          <h4>${item.name}</h4>
          <div class="cart-item-wood">🪵 ${item.woodLabel || 'Solid Seasoned Timber'}</div>
          <div class="qty-ctrl-row">
            <div class="qty-btns">
              <button onclick="changeQty('${item.id}', -1)">−</button>
              <span>${item.qty}</span>
              <button onclick="changeQty('${item.id}', 1)">+</button>
            </div>
            <button class="btn-remove-item" onclick="removeCartItem('${item.id}')">Remove</button>
          </div>
        </div>
      </div>
    `;
  }).join("");
}

function openCart() {
  renderCartDrawer();
  const overlay = document.getElementById("overlay");
  const drawer = document.getElementById("cartDrawer");
  if (overlay) overlay.classList.add("open");
  if (drawer) drawer.classList.add("open");
  document.body.classList.add("no-scroll");
}

function closeCart() {
  const drawer = document.getElementById("cartDrawer");
  if (drawer) drawer.classList.remove("open");
  const wish = document.getElementById("wishlistDrawer");
  const pdp = document.getElementById("pdpModalOverlay");
  const overlay = document.getElementById("overlay");
  if ((!wish || !wish.classList.contains("open")) && (!pdp || !pdp.classList.contains("open"))) {
    if (overlay) overlay.classList.remove("open");
    document.body.classList.remove("no-scroll");
  }
}

function toggleWishlist(id) {
  const strId = String(id);
  if (wishlist.includes(strId)) {
    wishlist = wishlist.filter(x => x !== strId);
    showToast("Removed from wishlist");
  } else {
    wishlist.push(strId);
    showToast("❤️ Saved to your wishlist");
  }
  localStorage.setItem("bf_wishlist", JSON.stringify(wishlist));
  saveCart();
  renderProducts();
}

function openWishlist() {
  const itemsContainer = document.getElementById("wishlistDrawerItems");
  const savedProducts = products.filter(p => wishlist.includes(String(p.id)));

  if (!itemsContainer) return;

  if (savedProducts.length === 0) {
    itemsContainer.innerHTML = `<div class="drawer-empty"><p>No saved items yet.</p></div>`;
  } else {
    const defaultImg = getAsset("furniture");
    itemsContainer.innerHTML = savedProducts.map(p => {
      const thumb = (p.images && p.images.length > 0) ? p.images[0] : defaultImg;
      return `
        <div class="cart-item-row">
          <img src="${thumb}" alt="${p.name}" class="cart-item-img">
          <div class="cart-item-info">
            <h4>${p.name}</h4>
            <div class="cart-item-wood">🪵 ${p.woodLabel}</div>
            <div style="display:flex;gap:10px;margin-top:8px;">
              <button class="btn btn-gold" style="padding:6px 12px;font-size:11px;" onclick="addToCart('${p.id}');">Add to Inquiry</button>
              <button class="btn-remove-item" onclick="toggleWishlist('${p.id}'); openWishlist();">Remove</button>
            </div>
          </div>
        </div>
      `;
    }).join("");
  }

  const overlay = document.getElementById("overlay");
  const drawer = document.getElementById("wishlistDrawer");
  if (overlay) overlay.classList.add("open");
  if (drawer) drawer.classList.add("open");
  document.body.classList.add("no-scroll");
}

function closeWishlist() {
  const drawer = document.getElementById("wishlistDrawer");
  if (drawer) drawer.classList.remove("open");
  const cartDr = document.getElementById("cartDrawer");
  const pdp = document.getElementById("pdpModalOverlay");
  const overlay = document.getElementById("overlay");
  if ((!cartDr || !cartDr.classList.contains("open")) && (!pdp || !pdp.classList.contains("open"))) {
    if (overlay) overlay.classList.remove("open");
    document.body.classList.remove("no-scroll");
  }
}

function closeAllDrawers() {
  closeCart();
  closeWishlist();
  closeProductDetailModal();
  closeMobileNav();
}

function checkoutWhatsApp() {
  if (cart.length === 0) return;
  let text = `*👑 BAKHTAWAR FURNITURE — BESPOKE INQUIRY*\n`;
  text += `--------------------------------------\n`;
  cart.forEach((i, idx) => {
    text += `${idx + 1}. *${i.name}* (Qty: ${i.qty})\n`;
  });
  text += `--------------------------------------\n`;
  text += `*Delivery:* White-Glove In-Home Setup (Lahore & Nationwide)\n`;
  text += `*Showroom:* ${STORE_ADDRESS}\n\n`;
  text += `Please review my selected pieces and share official quotation, timber availability, and production timeline.`;
  window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`, "_blank");
}

function submitCustomQuote() {
  const name = document.getElementById("custName").value.trim();
  const phone = document.getElementById("custPhone").value.trim();
  const type = document.getElementById("custType").value;
  const wood = document.getElementById("custWood").value;
  const notes = document.getElementById("custNotes").value.trim();

  if (!name || !phone) {
    showToast("⚠️ Please enter your name and phone number");
    return;
  }

  let text = `*🛠️ CUSTOM BESPOKE FURNITURE INQUIRY*\n`;
  text += `• *Name:* ${name}\n`;
  text += `• *Contact:* ${phone}\n`;
  text += `• *Furniture Type:* ${type}\n`;
  text += `• *Wood Preference:* ${wood}\n`;
  if (notes) text += `• *Design & Space Notes:* ${notes}\n`;
  text += `\nPlease review my custom requirements and provide an estimated quote.`;
  window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`, "_blank");
}

function sendShowroomInquiry() {
  const name = document.getElementById("inqName").value.trim();
  const phone = document.getElementById("inqPhone").value.trim();
  const msg = document.getElementById("inqMsg").value.trim();

  if (!name || !phone) {
    showToast("⚠️ Please provide your name & contact number");
    return;
  }

  let text = `Hello Bakhtawar Furniture Lahore,\nMy name is *${name}* (${phone}).\n`;
  if (msg) text += `Inquiry: ${msg}`;
  window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`, "_blank");
}

function toggleFaq(btn) {
  btn.parentElement.classList.toggle("open");
}

function showToast(msg) {
  const toast = document.getElementById("toast");
  if (!toast) return;
  document.getElementById("toastMsg").textContent = msg;
  toast.classList.add("show");
  clearTimeout(window._toastTimer);
  window._toastTimer = setTimeout(() => toast.classList.remove("show"), 2600);
}

function toggleMobileNav() {
  const drawer = document.getElementById("mobileNavDrawer");
  if (drawer) drawer.classList.toggle("open");
}

function closeMobileNav() {
  const drawer = document.getElementById("mobileNavDrawer");
  if (drawer) drawer.classList.remove("open");
}

// Boot Engine
document.addEventListener("DOMContentLoaded", () => {
  // The Shopify collection/product templates have their own rendering.
  // Only boot the legacy demo catalog on pages that actually contain #prodGrid.
  const hasLegacyCatalog = !!document.getElementById("prodGrid");
  if (hasLegacyCatalog) {
    initProducts();
    renderCategories();
    renderProducts();
  }
  saveCart();
});


/* =========================================================
   PREMIUM MOTION ENGINE
   ========================================================= */
function initPremiumMotion() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Header depth on scroll
  const header = document.getElementById('header');
  const syncHeader = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
  };
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  if (reduceMotion) {
    document.querySelectorAll('section, .section-header, .trust-grid, .review-grid, .prod-grid, .shop-toolbar, .custom-grid, .craft-grid, .contact-grid').forEach(el => {
      el.classList.add('motion-reveal');
      el.classList.add('is-visible');
    });
    return;
  }

  // Add reveal classes to major content blocks.
  const targets = document.querySelectorAll(
    'main > section, .section-header, .trust-grid, .review-grid, .prod-grid, .shop-toolbar, .custom-grid, .craft-grid, .contact-grid, .faq-wrap'
  );
  targets.forEach((el, i) => {
    if (!el.classList.contains('motion-reveal') && !el.classList.contains('motion-stagger')) {
      el.classList.add(i % 4 === 1 ? 'motion-reveal' : 'motion-reveal');
    }
  });

  // Stagger card collections.
  document.querySelectorAll('.trust-grid, .review-grid, .cat-carousel').forEach(el => {
    el.classList.add('motion-stagger');
  });

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -45px 0px' });

  document.querySelectorAll('.motion-reveal, .motion-stagger').forEach(el => observer.observe(el));

  // Hero card tilt — disabled on touch devices.
  const heroCard = document.querySelector('.hero-card');
  const heroWrap = document.querySelector('.hero-card-wrap');
  if (heroCard && heroWrap && window.matchMedia('(hover:hover)').matches) {
    heroWrap.addEventListener('mousemove', (e) => {
      const r = heroWrap.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - .5;
      const y = (e.clientY - r.top) / r.height - .5;
      heroCard.style.transform = `perspective(1100px) rotateY(${x * 5}deg) rotateX(${y * -4}deg) translateY(-3px)`;
    });
    heroWrap.addEventListener('mouseleave', () => {
      heroCard.style.transform = '';
    });
  }

  // Subtle hero image parallax.
  const heroImg = document.getElementById('heroPreviewImg');
  if (heroImg) {
    let ticking = false;
    const parallax = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const y = Math.min(window.scrollY, 500);
          heroImg.style.transform = `scale(1.04) translate3d(0, ${y * .035}px, 0)`;
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', parallax, { passive: true });
    parallax();
  }

  // Observe dynamically-rendered Shopify product cards.
  const productGrid = document.getElementById('prodGrid');
  if (productGrid) {
    const productObserver = new MutationObserver(() => {
      productGrid.querySelectorAll('.prod-card:not(.motion-reveal)').forEach(card => {
        card.classList.add('motion-reveal');
        observer.observe(card);
      });
    });
    productObserver.observe(productGrid, { childList: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Let the existing theme boot first, then enhance it.
  requestAnimationFrame(() => requestAnimationFrame(initPremiumMotion));
});
